export enum DialogWidth {
  Small = "505px",
  Medium = "605px",
  Large = "805px",
  ExtraLarge = "905px",
}
